import React, { useState, useEffect, useRef } from 'react';
import useFetch from '../../useFetch'
import { ValidateLogin, ForgotAcc } from '../../Services/LoginService'
import { Link } from "react-router-dom";
import { useHistory, BrowserRouter as Router, Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { SendEmail } from "../../Services/EmailService"
import { msalInstance } from "../../Services/AzServices";
import { PublicClientApplication } from "@azure/msal-browser";
import Homepage from '../Shared/Homepage'
import Footer from '../Shared/AllFooter'
import { Row, Col, Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Background from '../../components/background';
import '../../styles/Login.scss'
import { Divider, TextField, Button, Typography, FormControl, InputAdornment, IconButton, Checkbox, FormControlLabel, Box, Modal, CircularProgress, Tooltip } from '@mui/material';
import { IconMailFilled, IconLockFilled, IconEye, IconEyeOff, IconLogin, IconUserSearch, IconX } from '@tabler/icons-react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { isLoggedIn } from '../../Services/Auth';
import { history } from '../../Services/History';
import { logPageViews, GetIpAddress, UserSession, VerifyTokenAcc } from '../../Services/LoginService';
import { browserName, isMobile } from 'react-device-detect';
import * as Bowser from "bowser";





const Login = () => {
  // const Bowser = require("bowser");
  // const browser = Bowser.getParser(window.navigator.userAgent);

  // console.log(`The current browser name is "${browser.getBrowserName()}"`);
  function adjustLayout() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  const search = useLocation().search;
  const params = new URLSearchParams(search);
  const [interId, SetinterId] = useState(params.get('logout'))
  const [tokenId, SetTokenId] = useState(params.get('token'))

  window.addEventListener('resize', adjustLayout);
  window.addEventListener('orientationchange', adjustLayout);
  document.addEventListener('DOMContentLoaded', adjustLayout);
  const history = useHistory();

  useEffect(() => {
    logPage("Login")

    if (isLoggedIn()) {
      history.replace('/Home'); // Redirect if already logged in
      window.location.reload();
    }

    const handlePopState = () => {
      if (isLoggedIn()) {
        history.replace('/Home'); // Prevent going back to login page
        window.location.reload();
      }
    };


    window.addEventListener('popstate', handlePopState);


    return () => {
      window.removeEventListener('popstate', handlePopState);
    };

  }, []);

  async function logPage(pageName, input1, input2) {
    await logPageViews(pageName, input1, input2)
  }

  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const [CheckIp, setCheckIp] = useState('');
  const [CheckIpIsFalse, setCheckIpIsFalse] = useState(false);

  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
      // Fetch IP address from ipify API
      // fetch('https://api.ipify.org?format=json')
      //   .then(response => response.json())
      //   .then(data => {
      //     setIpAddress(data.ip);
      //     localStorage.setItem('ip', data.ip); // Store IP address in localStorage
      //   })
      //   .catch(error => console.error('Error fetching IP address:', error));
      setIp()
async function setIp() {
  setIpAddress(await GetIpAddress());
 //localStorage.setItem("ip", await GetIpAddress())


}


    }, []);
  useEffect(() => {
    localStorage.setItem("documentRefer", document.referrer)
    
    if (interId == "true") {
      console.log(interId)
    } else {
      checkURLAndAIp()
    }
    if (tokenId != null) {
      // console.log('not null')
      // console.log(tokenId)
      CheckTokenAthensValid(tokenId)
    } else {
      console.log('null')
    }



    if (localStorage.getItem("remember") === 'undefined' || localStorage.getItem("remember") === null) {

    } else {
      //alert(localStorage.getItem('remember'))
      if (localStorage.getItem('remember') === 'true') {
        setRememberMe(true)
        setPassword(localStorage.getItem("pass"))
        setEmail(localStorage.getItem("email"))
      }

    }
    async function CheckTokenAthensValid(tok = '') {
      
      //setToken(await VerifyTokenAcc(id))
      //alert(tok)
      const token = await VerifyTokenAcc(tok)
      if (token.success && token.data.isSuccess) {
        localStorage.setItem("ip", await GetIpAddress())
        localStorage.setItem('token', token.data.token);
        localStorage.setItem('refreshToken', token.data.refreshToken);
        localStorage.setItem('sessionId', token.data.sessionId);
        localStorage.setItem('fullName', token.data.fullName);
        localStorage.setItem('email', token.data.fullName);
        localStorage.setItem('phoneNumber', token.data.phoneNumber);
        localStorage.setItem('address', token.data.address);
        localStorage.setItem('company', token.data.company);
        localStorage.setItem('occupation', token.data.occupation);
        localStorage.setItem('userId', token.data.userId);
        localStorage.setItem('groupId', token.data.groupId);
        localStorage.setItem('userType', token.data.userType);
        localStorage.setItem('gateway', token.data.eStoreWebModels[0].imGateWay.toLowerCase());
        localStorage.setItem('countryversionList', token.data.eStoreWebModelsCountryVersion);
        localStorage.setItem('Activecountryversion', token.data.eStoreWebModels[0].countryName);
        localStorage.setItem('subscriptionType', token.data.eStoreWebModels[0].subType);
        localStorage.setItem('subscriptionStart', token.data.eStoreWebModels[0].subcriptionStartDate);
        localStorage.setItem('subscriptionEnd', token.data.eStoreWebModels[0].subcriptionEndDate);
        localStorage.setItem('licenseCount', token.data.eStoreWebModels[0].licenseCount);
        var result = Bowser.getParser(window.navigator.userAgent);
        //result.parsedResult.browser.version
        // console.log(token.data.sessionId)
        // console.log(await GetIpAddress())
        // console.log(document.referrer)
        // console.log(browserName)
        // console.log(result.parsedResult.browser.version)
        console.log(await UserSession('Add', token.data.sessionId, '', token.data.userId, await GetIpAddress(), '', 'openathens', 'Web', browserName, result.parsedResult.browser.version, ''))

     
        setError({ email: false, password: false });
        window.location.href = '/Home';
        // history.replace('/Home');
        // Redirect to the home page
        //window.location.reload();
      } else {
        console.log('suc')

      }
    }

    async function checkURLAndAIp() {

      const tokenResponse = await ValidateLogin(email, password, '', await GetIpAddress(), document.referrer, '', '', '', '', '');

      if (tokenResponse.success && tokenResponse.data.isSuccess) {
        localStorage.setItem("ip", await GetIpAddress())
        localStorage.setItem('token', tokenResponse.data.token);
        localStorage.setItem('refreshToken', tokenResponse.data.refreshToken);
        localStorage.setItem('sessionId', tokenResponse.data.sessionId);
        localStorage.setItem('fullName', tokenResponse.data.fullName);
        localStorage.setItem('email', email);
        localStorage.setItem('phoneNumber', tokenResponse.data.phoneNumber);
        localStorage.setItem('address', tokenResponse.data.address);
        localStorage.setItem('company', tokenResponse.data.company);
        localStorage.setItem('occupation', tokenResponse.data.occupation);
        localStorage.setItem('userId', tokenResponse.data.userId);
        localStorage.setItem('groupId', tokenResponse.data.groupId);
        localStorage.setItem('userType', tokenResponse.data.userType);
        localStorage.setItem('gateway', tokenResponse.data.eStoreWebModels[0].imGateWay);
        localStorage.setItem('countryversionList', tokenResponse.data.eStoreWebModelsCountryVersion);
        localStorage.setItem('Activecountryversion', tokenResponse.data.eStoreWebModels[0].countryName);
        localStorage.setItem('subscriptionType', tokenResponse.data.eStoreWebModels[0].subType);
        localStorage.setItem('subscriptionStart', tokenResponse.data.eStoreWebModels[0].subcriptionStartDate);
        localStorage.setItem('subscriptionEnd', tokenResponse.data.eStoreWebModels[0].subcriptionEndDate);
        localStorage.setItem('licenseCount', tokenResponse.data.eStoreWebModels[0].licenseCount);
        var result = Bowser.getParser(window.navigator.userAgent);
        //result.parsedResult.browser.version
        await UserSession('Add', tokenResponse.data.sessionId, '', tokenResponse.data.userId, await GetIpAddress(), document.referrer, 'URLAndIP', 'Web', browserName, result.parsedResult.browser.version, '')

        setError({ email: false, password: false });
        // history.replace('/Home');
        // Redirect to the home page
        //window.location.reload();
         window.location.href = '/Home';
      } else {
        console.log('suc')

      }
    }

  }, []);


  //Shrink label when there's an autofill value 
  const [passwordHasValue, setPasswordHasValue] = React.useState(false);
  const [emailHasValue, setEmailHasValue] = React.useState(false);
  const [forgotPasswordEmailHasValue, setForgotPasswordEmailHasValue] = React.useState(false);
  const makeAnimationStartHandler = (stateSetter) => (e) => {
    const autofilled = !!e.target?.matches("*:-webkit-autofill");
    if (e.animationName === "mui-auto-fill" || e.animationName === "mui-auto-fill-cancel") {
      stateSetter(autofilled || e.target.value !== '');
    }
  };

  const [password, setPassword] = useState('');
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setPasswordHasValue(e.target.value !== '');
    setError((prevState) => ({ ...prevState, password: false }));
  };

  const [email, setEmail] = useState('');
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailHasValue(e.target.value !== '');
    setError((prevState) => ({ ...prevState, email: false }));
  };

  const [error, setError] = useState({ email: false, password: false, forgotPasswordEmail: false });
  const [emailErrorMessage, setEmailErrorMessage] = useState('');
  const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
  const [forgotPasswordEmailErrorMessage, setForgotPasswordEmailErrorMessage] = useState('');


  const handleClickShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };



  // User Verification
  const [token, setToken] = useState('')
  const OpenAthens = async (event) => {
    window.location.href = 'https://openathens.mims.com.au/Drugs4dent/';
    //window.location.href = 'https://www-mimsdrugs4dent-com.eu1.proxy.openathens.net/';
    //window.location.reload();
    //console.log(window.location.href = 'https://openathens.mims.com.au/drugs4dent')

  }
  const VerifyUser = async (event) => {
    event.preventDefault();
    // Validate email and password fields before making API call
    if (email === '') {
      setError((prevState) => ({ ...prevState, email: true }));
      setEmailErrorMessage('Email is required');
      return; // Exit early if validation fails
    } else if (!email.includes('@')) {
      setError((prevState) => ({ ...prevState, email: true }));
      setEmailErrorMessage('Invalid email. Must include @');
      return; // Exit early if validation fails
    } else {
      setError((prevState) => ({ ...prevState, email: false }));
    }

    if (password === '') {
      setError((prevState) => ({ ...prevState, password: true }));
      setPasswordErrorMessage('Password is required');
      return; // Exit early if validation fails
    } else {
      setError((prevState) => ({ ...prevState, password: false }));
    }

    // Submit form logic if validation passes
    document.getElementById('loader').style.display = 'flex';

    try {
      logPage("Login", email)
      const tokenResponse = await ValidateLogin(email, password);


      if (tokenResponse.success && tokenResponse.data.isSuccess) {
        localStorage.setItem('token', tokenResponse.data.token);
        localStorage.setItem('refreshToken', tokenResponse.data.refreshToken);
        localStorage.setItem('sessionId', tokenResponse.data.sessionId);
        localStorage.setItem('fullName', tokenResponse.data.fullName);
        localStorage.setItem('email', email);
        localStorage.setItem('phoneNumber', tokenResponse.data.phoneNumber);
        localStorage.setItem('address', tokenResponse.data.address);
        localStorage.setItem('company', tokenResponse.data.company);
        localStorage.setItem('occupation', tokenResponse.data.occupation);
        localStorage.setItem('userId', tokenResponse.data.userId);
        localStorage.setItem('groupId', tokenResponse.data.groupId);
        localStorage.setItem('userType', tokenResponse.data.userType);
        localStorage.setItem('gateway', tokenResponse.data.eStoreWebModels[0].imGateWay.toLowerCase());

        localStorage.setItem('subscriptionType', tokenResponse.data.eStoreWebModels[0].subType);
        localStorage.setItem('subscriptionStart', tokenResponse.data.eStoreWebModels[0].subcriptionStartDate);
        localStorage.setItem('subscriptionEnd', tokenResponse.data.eStoreWebModels[0].subcriptionEndDate);
        localStorage.setItem('licenseCount', tokenResponse.data.eStoreWebModels[0].licenseCount);
        localStorage.setItem('countryversionList', tokenResponse.data.eStoreWebModelsCountryVersion);
        localStorage.setItem('Activecountryversion', tokenResponse.data.eStoreWebModels[0].countryName);
        localStorage.setItem('remember', rememberMe);
        setError({ email: false, password: false });
        var result = Bowser.getParser(window.navigator.userAgent);
        //result.parsedResult.browser.version await GetIpAddress() 
        //document.referrer
        await UserSession('Add', tokenResponse.data.sessionId, '', tokenResponse.data.userId, await GetIpAddress(), document.referrer, 'Login', 'Web', browserName, result.parsedResult.browser.version, '')

        if (rememberMe) {
          localStorage.setItem('pass', password);

        }


        window.location.href = '/Home';
        // history.replace('/Home');
        // Redirect to the home pagey
        //window.location.reload();

      } else {
        // Handle API response errors
        localStorage.removeItem('token');

        if (tokenResponse.data.reason === 'expired') {
          setError((prevState) => ({ ...prevState, email: true }));
          setEmailErrorMessage('Account has expired');
        } else {
          setError((prevState) => ({ ...prevState, email: true, password: true }));
          setEmailErrorMessage('Invalid Email or Password');
          setPasswordErrorMessage('Invalid Email or Password');
        }
        document.getElementById('loader').style.display = 'none';
        localStorage.clear();
      }
    } catch (error) {
      console.error('An error occurred:', error);
      setError({ email: true, password: true });
      setEmailErrorMessage('An unexpected error occurred');
      setPasswordErrorMessage('An unexpected error occurred');
      document.getElementById('loader').style.display = 'none'; // Hide loader
    } 
  };



  // Forgot password
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const handleForgotPasswordEmailChange = (e) => {
    setForgotPasswordEmail(e.target.value);
    setForgotPasswordEmailHasValue(e.target.value !== '');
    setError((prevState) => ({ ...prevState, forgotPasswordEmail: false }));
  };
  const onAzureClick = (e) => {
    console.log(e)

    CheckAzureUser()
    async function CheckAzureUser() {
      if (e !== null && e !== "") {
        localStorage.setItem("documentRefer", document.referrer)
        const tokenResponse = await ValidateLogin(email, password, e, await GetIpAddress(), document.referrer, '', '', '', '', '');

        if (tokenResponse.success && tokenResponse.data.isSuccess) {
          localStorage.setItem("ip", await GetIpAddress())
          localStorage.setItem('token', tokenResponse.data.token);
          localStorage.setItem('refreshToken', tokenResponse.data.refreshToken);
          localStorage.setItem('sessionId', tokenResponse.data.sessionId);
          localStorage.setItem('fullName', tokenResponse.data.fullName);
          localStorage.setItem('email', email);
          localStorage.setItem('phoneNumber', tokenResponse.data.phoneNumber);
          localStorage.setItem('address', tokenResponse.data.address);
          localStorage.setItem('company', tokenResponse.data.company);
          localStorage.setItem('occupation', tokenResponse.data.occupation);
          localStorage.setItem('userId', tokenResponse.data.userId);
          localStorage.setItem('groupId', tokenResponse.data.groupId);
          localStorage.setItem('userType', tokenResponse.data.userType);
          localStorage.setItem('gateway', tokenResponse.data.eStoreWebModels[0].imGateWay.toLowerCase());
          localStorage.setItem('countryversionList', tokenResponse.data.eStoreWebModelsCountryVersion);
          localStorage.setItem('Activecountryversion', tokenResponse.data.eStoreWebModels[0].countryName);
          localStorage.setItem('subscriptionType', tokenResponse.data.eStoreWebModels[0].subType);
          localStorage.setItem('subscriptionStart', tokenResponse.data.eStoreWebModels[0].subcriptionStartDate);
          localStorage.setItem('subscriptionEnd', tokenResponse.data.eStoreWebModels[0].subcriptionEndDate);
          localStorage.setItem('licenseCount', tokenResponse.data.eStoreWebModels[0].licenseCount);
          var result = Bowser.getParser(window.navigator.userAgent);
          //result.parsedResult.browser.version
          //console.log()
          await UserSession('Add', tokenResponse.data.sessionId, '', tokenResponse.data.userId, await GetIpAddress(), document.referrer, 'AzureAD', 'Web', browserName, result.parsedResult.browser.version, '')

          setError({ email: false, password: false });
          history.replace('/Home');
          // Redirect to the home page
          //window.location.reload();
        } else if (tokenResponse.success && !tokenResponse.data.isSuccess) {
          setopenAzure(true);
          document.getElementById('loader').style.display = 'none';
          console.log('false azure')
        }
      }

    }

  };
  // Forgot password modal
  const [open, setOpen] = useState(false);
  const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);

  // Open Modal
  const handleOpen = () => {
    setOpen(true);
  };

  // Close modal then proceed to login
  const handleClose = () => {
    setOpen(false);
    setIsEmailSubmitted(false);
    setForgotPasswordEmail('')
    setError((prevState) => ({ ...prevState, forgotPasswordEmail: false }));
  };

  const [template, setTemplate] = useState('');
  useEffect(() => {
    fetch('/ForgotPasswordEmail.html')
      .then(response => response.text())
      .then(data => setTemplate(data));
  }, []);
  const sendEmail = (forgotPasswordEmail, resetPasswordUrl) => {
    if (template) {
      //console.log(email)
      const processedTemplate = template
        .replace(/{resetPasswordUrl}/g, resetPasswordUrl)

      SendEmail(
        forgotPasswordEmail,
        processedTemplate,
        '',
        'Reset Your Password'
      );
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false); // Stop loading
        setIsEmailSubmitted(true); // Set to success state
      }, 1000);

    }
  };

  const [forgotPasswordToken, setforgotPasswordToken] = useState('')
  const [isLoading, setIsLoading] = useState(false); // State for loading
  async function ForgotPasswordVerifyUser(event) {
    event.preventDefault();
    if (forgotPasswordEmail === '') {
      setError((prevState) => ({ ...prevState, forgotPasswordEmail: true }));
      setForgotPasswordEmailErrorMessage('Email is required');
    }
    else {
      setforgotPasswordToken(await ForgotAcc(forgotPasswordEmail));
      logPage("Forgot Password", forgotPasswordEmail)
    }
  }
  useEffect(() => {
    if (forgotPasswordToken) {


      // Check email existence
      if (forgotPasswordToken.data.reason === "invalid") {
        setError((prevState) => ({ ...prevState, forgotPasswordEmail: true }));
        setForgotPasswordEmailErrorMessage('Invalid email');

      } else {
        setError((prevState) => ({ ...prevState, forgotPasswordEmail: false }));
      }

      // Sign up successful
      if (forgotPasswordToken.data.isSuccess) {
        //   const verificationUrl = `https://www.mimsdrugs4dent.com/`;
        //   sendEmail( fullName, verificationUrl, email, password);

        let resetPasswordUrl = "https://www.mimsdrugs4dent.com/ResetPassword/" + forgotPasswordToken.data.token;
        sendEmail(forgotPasswordEmail, resetPasswordUrl);
      }

    }
  }, [forgotPasswordToken]);

  const [openAzure, setopenAzure] = useState(false);
  // Close modal then proceed to login
  const handleCloseAzure = () => {
    setopenAzure(false);
  };
  const handleOpenAzure = () => {
    setopenAzure(true);
  };
  return (
    <>

      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <Modal id="modal" open={openAzure} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" onClose={isEmailSubmitted || isLoading ? undefined : handleClose}>
        <Box id="forgotPassword">
          <IconButton
            onClick={handleCloseAzure}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              color: 'grey.500',
            }}
          >

            <IconX sx={{ fontSize: 32 }} />

          </IconButton>

          {/* Original display */}
          <>
            <img
              src="/ForgotPassword.svg"
              alt="Illustration"
              style={{ maxWidth: '240px', width: '100%', height: 'auto', marginBottom: '16px' }}
            />
            <Typography id="modal-modal-title" variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', color: '#0262AB', marginTop: '20px' }}>
              Account not registered!
            </Typography>


            <Button
              onClick={handleCloseAzure}
              variant="contained"
              color="primary"
              sx={{
                borderRadius: '32px',
                padding: '16px 32px',
                fontSize: '16px',
                marginTop: '16px',
                backgroundColor: '#0262AB',
                '&:hover': { boxShadow: '0px 8px 24px 0px rgba(0, 153, 255, 0.15)' },
              }}

            >
              Confirm
            </Button>
          </>

        </Box>
      </Modal>
      <Modal id="modal" open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" onClose={isEmailSubmitted || isLoading ? undefined : handleClose}>
        <Box id="forgotPassword">
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              color: 'grey.500',
            }}
          >

            <IconX sx={{ fontSize: 32 }} />

          </IconButton>
          {isLoading ? (
            <CircularProgress sx={{ color: '#0262AB', margin: 'auto', display: 'block' }} />
          ) : isEmailSubmitted ? (
            // Display this after the email search is successful
            <>
              <img
                src="/ForgotPasswordMail.svg"
                alt="Illustration"
                style={{ maxWidth: '240px', width: '100%', height: 'auto', marginBottom: '16px' }}
              />
              <Typography id="modal-modal-title" variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', color: '#0262AB' }}>
                Check your mail!
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2, mb: 4, color: '#727272', fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' } }}>
                An email with password reset instructions has been sent to <strong>{forgotPasswordEmail}</strong>
              </Typography>
              <Button
                onClick={handleClose}
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: '32px',
                  padding: '16px 32px',
                  fontSize: '16px',
                  marginTop: '16px',
                  backgroundColor: '#0262AB',
                  '&:hover': { boxShadow: '0px 8px 24px 0px rgba(0, 153, 255, 0.15)' },
                }}
              >
                Got it
              </Button>
            </>
          ) : (
            // Original display
            <>
              <img
                src="/ForgotPassword.svg"
                alt="Illustration"
                style={{ maxWidth: '240px', width: '100%', height: 'auto', marginBottom: '16px' }}
              />
              <Typography id="modal-modal-title" variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', color: '#0262AB' }}>
                Forgot your password?
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2, mb: 4, color: '#727272', fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' } }}>
                No worries! Just enter your account email and we'll help you recover your access
              </Typography>
              <form onSubmit={ForgotPasswordVerifyUser}>
                <FormControl margin="normal" required fullWidth error={error.email}>
                  <TextField
                    id="forgotPasswordEmail"
                    type="email"
                    value={forgotPasswordEmail}
                    onChange={handleForgotPasswordEmailChange}
                    fullWidth
                    autoComplete='email'
                    error={error.forgotPasswordEmail}
                    helperText={
                      error.forgotPasswordEmail ? forgotPasswordEmailErrorMessage : ''
                    }
                    label="Email"
                    variant="outlined"
                    InputLabelProps={{ shrink: forgotPasswordEmailHasValue, sx: { fontWeight: 'bold' } }}
                    InputProps={{
                      onAnimationStart: makeAnimationStartHandler(setForgotPasswordEmailHasValue),
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconMailFilled sx={{ fontSize: 16, pl: '10px' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                <Button
                  onClick={ForgotPasswordVerifyUser}
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{
                    borderRadius: '16px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    marginTop: '16px',
                    backgroundColor: '#0262AB',
                    '&:hover': { boxShadow: '0px 8px 24px 0px rgba(0, 153, 255, 0.15)' },
                  }}
                  startIcon={<IconUserSearch />}
                >
                  Search Account
                </Button>
              </form>
            </>
          )}
        </Box>
      </Modal>
      <Container fluid id="loginPage">
        <Row className="h-100">
          <Col xl={5} lg={6} className="d-flex d-md-flex flex-column align-items-center justify-content-lg-start" id="loginContainer" >


            <form onSubmit={VerifyUser} id="loginForm">
              <Tooltip title={`Your IP address is ${ipAddress || localStorage.getItem('ip')}`}>
                          <a href="/" className="align-self-center align-self-lg-start">
                <img src="/Drugs4dent.svg" alt="Logo" id="loginLogo" />
              </a>
                        </Tooltip>
              {/* <a href="/" className="align-self-center align-self-lg-start">
                <img src="/Drugs4dent.svg" alt="Logo" id="loginLogo" />
              </a> */}
              <h1 className="align-self-start">Sign In</h1>
              <FormControl margin="normal" required fullWidth error={error.email}>
                <TextField
                  id="email"
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  fullWidth
                  autoComplete='email'
                  error={error.email}
                  helperText={
                    error.email ? emailErrorMessage : ''
                  }
                  label="Email"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: emailHasValue, sx: {
                      fontWeight: 'bold', // Change this value to the desired font weight
                    },
                  }}
                  InputProps={{
                    onAnimationStart: makeAnimationStartHandler(setEmailHasValue),
                    startAdornment: (
                      <InputAdornment position="start" >
                        <IconMailFilled sx={{ fontSize: 16, pl: '10px' }} />
                      </InputAdornment>
                    ),
                  }}

                />
              </FormControl>

              <FormControl margin="normal" required fullWidth error={error.password}>
                <TextField
                  id="password"
                  label="Password"
                  variant="outlined"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={handlePasswordChange}
                  fullWidth
                  error={error.password}
                  helperText={
                    error.password ? passwordErrorMessage : ''
                  }
                  InputLabelProps={{
                    shrink: passwordHasValue, sx: {
                      fontWeight: 'bold', // Change this value to the desired font weight
                    },
                  }}
                  InputProps={{
                    onAnimationStart: makeAnimationStartHandler(setPasswordHasValue),
                    startAdornment: (
                      <InputAdornment position="start" >
                        <IconLockFilled sx={{ fontSize: 16, pl: '10px' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <IconEyeOff /> : <IconEye />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              <div className="d-flex justify-content-between align-items-center w-100">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Remember Me"
                />
                <a onClick={handleOpen} style={{ color: '#016aaa', cursor: 'pointer' }}> Forgot Password?</a>
              </div>
              <Button id="loginButton" onClick={VerifyUser} type="submit" fullWidth variant="contained" color="primary" startIcon={<IconLogin />}>
                Sign In
              </Button>
              <Divider style={{ color: "#727272" }}>or</Divider>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>

                <Button id="AthensButton" onClick={OpenAthens} fullWidth
                  sx={{ justifyContent: "space-evenly" }}
                  variant="outlined" startIcon={
                    <img
                      src={`${process.env.PUBLIC_URL}/OpenAthens.SVG`}
                      alt="OpenAthens Icon"
                      style={{ width: '24px', height: '24px', margin: '0px' }}
                    />
                  }>
                  Continue with OpenAthens
                </Button>
              </div>
              {/* <Divider style={{color: "#727272",marginTop:'20px'}}>or</Divider> */}
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Button id="AthensButton" fullWidth variant="outlined"
                  //type="submit"
                  //isLoading={isLoading}
                  sx={{ justifyContent: "space-evenly" }}
                  onClick={async () => {
                    try {
                      //setLoading(true)
                      await msalInstance.initialize();
                      const loginResponse = await msalInstance.loginPopup({
                        scopes: ["User.Read"],
                      });
                      console.log('Your tenant id: ' + loginResponse.tenantId)

                      onAzureClick(loginResponse.tenantId)

                    } catch (error) {
                      console.log(error);
                      //setLoading(false)
                    }
                  }}
                  isFullWidth={true}
                  variation="primary"
                  startIcon={
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                      alt="OpenAthens Icon"
                      style={{ width: '24px', height: '24px', margin: '0px' }}
                    />
                  }
                >
                  Continue with Microsoft
                </Button>

                {/* <Button id="AthensButton" onClick={handleOpenAzure} fullWidth variant="outlined"   
              // endIcon={
              //   <img
              //     src={`${process.env.PUBLIC_URL}/OpenAthens.SVG`}
              //     alt="OpenAthens Icon"
              //     style={{ width: '24px', height: '24px', margin: '0px' }}
              //   />
              // }
              >
                Continue with Azure AD
              </Button> */}
              </div>

            </form>
            <div id="signupLink">
              Don't have an account? <a href="/SignUp" id="signupText">Sign up for a 30-day trial</a>
            </div>


          </Col>
          <Col xl={7} lg={6} className="d-flex flex-column align-items-center d-none d-lg-flex" id="carouselContainer">
            {/* Content for the second column */}
            <h1 style={{ textAlign: 'center' }} >Discover What MIMS Drugs4dent® Can Do for You</h1>
            <Carousel
              showArrows={true}
              autoPlay={true}
              interval={7000}
              infiniteLoop={true}
              showThumbs={false}
              showStatus={false}

              className="carousel"
            >
              <div className="carouselItem">
                <img src="/carousel/DentalSpecificDrugInformation.svg" alt="Illustration 1" className="illustration" />
                <div className="carousel-caption">
                  <h3>Dental-Specific Drug Information</h3>
                  <p style={{ textAlign: 'center' }}>Succinct, dental-relevant drug information is provided about your patient’s medications to enable you to perform dental treatment safely with respect to medication use.</p>
                </div>
              </div>
              <div className="carouselItem">
                <img src="/carousel/TowardsSaferPrescribing.svg" alt="Illustration 2" className="illustration" />
                <div className="carousel-caption">
                  <h3>Towards Safer Prescribing</h3>
                  <p style={{ textAlign: 'center' }}>Paediatric dosing, drug and allergy interactions, contraindications, pregnancy and lactation recommendations are all provided to assist with safer prescribing.</p>
                </div>
              </div>
              <div className="carouselItem">
                <img src="/carousel/PatientEducation.svg" alt="Illustration 3" className="illustration" />
                <div className="carousel-caption">
                  <h3>Patient Education</h3>
                  <p style={{ textAlign: 'center' }}>Patient-friendly information is provided about the appropriate use of antibiotics for specific dental scenarios.</p>
                </div>
              </div>
              <div className="carouselItem">
                <img src="/carousel/ClinicalDecisionSupport.svg" alt="Illustration 4" className="illustration" />
                <div className="carousel-caption">
                  <h3>Clinical Decision Support</h3>
                  <p style={{ textAlign: 'center' }}>Medication related effects that can impact dental treatment are presented to assist with clinical decision making and safe treatment procedures. Examples include drugs associated with increased bleeding risk, infection risk and osteonecrosis of the jaw.</p>
                </div>
              </div>
            </Carousel>
          </Col>
        </Row>

      </Container>
      <Background />
    </>
  );
}

export default Login;